var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-button",
    {
      attrs: { pressed: _vm.toggle, variant: _vm.variant },
      on: {
        "update:pressed": function ($event) {
          _vm.toggle = $event
        },
        click: function ($event) {
          return _vm.$emit("toggle")
        },
      },
    },
    [_c("i", { class: _vm.iconClass }), _vm._v(" " + _vm._s(_vm.label))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }